module.exports = __webpack_public_path__ + "static/media/online.ee3ef083.ico";